import React from 'react';
import { MuiPickersUtilsProvider, DatePicker } from 'material-ui-pickers';
import DateFnsUtils from '@date-io/date-fns';
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles';

const materialTheme = createMuiTheme({
  typography: {
    fontFamily: ['Kanit', 'sans-serif'].join(','),
    useNextVariants: true,
  },
  overrides: {
    MuiPickersToolbar: {
      toolbar: {
        backgroundColor: '#009D9A',
      },
    },
    MuiPickersCalendarHeader: {
      switchHeader: {
        backgroundColor: 'white',
        color: '#009D9A',
      },
    },
    MuiOutlinedInput: {
      input: {
        padding: 7,
        height: '24px',
      },
      notchedOutline: {
        border: '1px solid #B8CFC3 !important',
        borderRadius: '2px',
      },
    },
    MuiPickersCalendar: {
      transitionContainer: {
        minHeight: '265px',
      },
    },
    MuiPickersDay: {
      isSelected: {
        backgroundColor: '#009D9A',
        opacity: '70%',
      },
      day: {
        fontSize: '0.85rem',
      },
    },
    MuiButton: {
      root: {
        color: '#009D9A !important',
      },
    },
    MuiTypography: {
      caption: {
        fontSize: '0.85rem',
      },
    },
  },
});

// const dateTheme = createMuiTheme({
//   typography: {
//     fontFamily: ['Kanit', 'sans-serif'].join(','),
//     useNextVariants: true,
//   },
//   '& .MuiInputBase-root': {
//     height: '38px',
//   },
// });

const CalendarDate = (props) => {
  const onDateChange = props.onDateChange ? props.onDateChange : (_) => {};
  const date = props.date ? props.date : new Date();

  const customStyle = {
    width: 110,
    marginTop: 4,
  };
  return (
    <MuiThemeProvider theme={materialTheme}>
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <div className='flex'>
          <DatePicker
            maxDate={new Date()}
            views={['year', 'month', 'day']}
            variant='outlined'
            style={customStyle}
            format='dd/MM/yyyy'
            value={date}
            onChange={(e) => onDateChange(e)}
            className={props.InputStyle}
          />
        </div>
      </MuiPickersUtilsProvider>
    </MuiThemeProvider>
  );
};

export default CalendarDate;
